import React from 'react'

import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { B2 } from '@zet/design-system/typography'
import { APP_NAME } from '@zet/end-points'
import { i18n } from '@zet/localization'

import CommissionType from './commissionType'

interface Props {
  commissionType: string
  brandCommission: string | number
  pendingDays: string | number
}

const PayoutTextExcludingLastDayHi: React.FC<Props> = (props) => {
  const { commissionType, brandCommission, pendingDays } = props
  return (
    <B2 className="text-grays-50 mt-2">
      <B2 className="text-grays-80">
        {i18n.t('myLeads.days', { days: pendingDays })}
      </B2>
      {i18n.t('myLeads.completeSale')}
      {APP_NAME !== MY_TEAMS_ADVISOR && (
        <CommissionType
          commissionType={commissionType}
          brandCommission={brandCommission}
        />
      )}
      {i18n.t('myLeads.earn')}
    </B2>
  )
}

const PayoutTextExcludingLastDayEn: React.FC<Props> = (props) => {
  const { commissionType, brandCommission, pendingDays } = props

  return (
    <B2 className="text-grays-50 mt-2">
      {i18n.t('myLeads.completeSale')}
      <B2 className="text-grays-80">
        {i18n.t('myLeads.days', { days: pendingDays })}
      </B2>
      {i18n.t('myLeads.earn')}
      <CommissionType
        commissionType={commissionType}
        brandCommission={brandCommission}
      />
    </B2>
  )
}

const PayoutTextExcludingLastDay: React.FC<Props> = (props) => {
  if (i18n.locale === 'en') {
    return <PayoutTextExcludingLastDayEn {...props} />
  } else {
    return <PayoutTextExcludingLastDayHi {...props} />
  }
}

export default PayoutTextExcludingLastDay
